module.exports = __webpack_public_path__ + "static/media/17.317b0aa2.mp3";